<template>
  <v-row justify="center">
    <v-dialog
      style="border-radius: 2px"
      v-model="show"
      persistent
      max-width="1000px"
    >
      <custom-modal
        title="Expense  Details"
        @onSubmit="SaveCategory"
        @onClose="close()"
        :isLoading="isLoading"
        :showSave="false"
      >
        <v-container fluid class="container">
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6" class="pt-0">
              <v-row class="pt-0">
                <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                  <h4>Reference number</h4>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="6"
                  class="pt-1.5 pb-1 text-right"
                >
                  <v-chip label>
                    {{
                      selectRow.reference_number
                        ? selectRow.reference_number
                        : "----"
                    }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                  <h4>Expense For</h4>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="6"
                  class="pt-1.5 pb-1 text-right"
                >
                  <!-- <v-chip label>
                    {{ selectRow.expense_for ? selectRow.expense_for : "----" }}
                  </v-chip> -->
                  <v-chip label>
                    {{ getExpenseFromName(selectRow) }}
                  </v-chip>

                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6" lg="6" class="pt-2 pb-1">
                  <h4>Date</h4>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  md="4"
                  lg="6"
                  class="pt-2 pb-1 text-right"
                >
                  <v-chip label>
                    {{ selectRow.date ? selectRow.date : "----" | formatDate }}
                  </v-chip>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" sm="6" md="6" lg="6" class="pt-2 pb-0">
                  <h4>Amount</h4>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="6"
                  class="pt-2 pb-0 text-right"
                >
                  <v-chip label>
                    {{ selectRow.amount ? selectRow.amount : "----" }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                  <h4>Expense Category</h4>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="6"
                  class="pt-1.5 pb-1 text-right"
                >
                  <v-chip label>
                    {{
                      selectRow.category.name ? selectRow.category.name : "----"
                    }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="12" md="6" lg="6" class="pt-0">
              <FileUpload
                :multiple="true"
                size="10000"
                icon="mdi-upload"
                autoupload="true"
                :url="'document/upload/Invoice/' + this.selectRow.id"
                :showDocumentView="true"
                :documentsUrl="'document/Invoice/' + this.selectRow.id"
                downloadUrl="document/:id/download"
                removeUrl="document/:id"
                ref="fileupload"
              ></FileUpload>
            </v-col>
          </v-row>
        </v-container>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import datePickComponent from "../../../components/base/DateComponent";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import FileUpload from "@/components/base/FileUpload";
import CustomModal from "@/components/base/CustomModal";

export default {
  data: () => ({}),

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    selectRow: {
      type: Object,
      default: {},
    },
  },
  components: {
    FileUpload,
    datePickComponent,
    CustomModal,
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("close", this.expenseCategory);
      },
    },
  },
  methods: {
    getfileupload(){
      this.$refs.fileupload.removeAllItems()
    },
    close() {
      this.show = false;
    },
    getExpenseFromName(row) {
    if (!row) return "----";

    switch (row.expense_for) {
      case "room":
        return row.room?.name || "Room";
      case "Warehouse":
        return row.warehouse?.name || "Warehouse";
      case "shop":
        return row.shop?.name || "Shop";
      case "kitchen":
        return row.kitchen?.name || "Kitchen";
      default:
        return row.expense_for;
    }
  },
  },
  

  watch: {},
};
</script>
